import { render, staticRenderFns } from "./GroupLinkRulesDialog.vue?vue&type=template&id=742b6853&scoped=true&"
import script from "./GroupLinkRulesDialog.vue?vue&type=script&lang=js&"
export * from "./GroupLinkRulesDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742b6853",
  null
  
)

export default component.exports